import axios from 'axios';
import { IDatabase } from '../../database';
import { rootGizmoConfigV2ToV3 } from '../../gizmos/utils';
import { IGizmo } from '../../types';

interface IParams {
  fid: string;
  context: {
    apiUrl: string;
    database?: IDatabase;
  };
}

/**
 * Get form signup root gizmo configs from the server
 *
 * @param {string} fid Flowy id of the form signup
 * @returns
 */
function getFormSignup({ fid, context }: IParams): Promise<IGizmo[]> {
  return new Promise<IGizmo[]>(async resolve => {
    const { apiUrl, database } = context;
    let rootGizmoConfigs: IGizmo[] = [];
    const url = `${apiUrl}/main_api/v1/form_auth/sign_up/${fid}`;

    try {
      const formSignupResponse = await axios.get(url);

      if (formSignupResponse.status === 200) {
        const { forms } = formSignupResponse.data;

        if (forms && Array.isArray(forms) && forms.length > 0) {
          // Overwrite serverValidation
          if (database) {
            for (const form of forms) {
              // Temporary fix for QR register
              if (form.id === '65a7f37902d68b001ee332bb' && form.questions) {
                const question = form.questions.find(
                  (q: any) => q.uid === 'curp_texto'
                );
                if (question?.options?.serverValidation?.flux) {
                  console.log('ffffffffffffffffffffflx.1: ', question.options.serverValidation.flux);
                  /**** DAY ONE ****/
                  // question.options.serverValidation.flux = "form = Form();\nregister = form.get_register();\ncurp = register.get_value(\"curp_texto\");\nrelated_curps = register.get_value(\"related_curps\");\nrelated_curp = register.has_related_curp_registrations(\"curp_texto\", curp, \"related_curps\", related_curps);\nif (related_curp == null) {\nform_mujeres = Form(\"63f5234b4732de0015a3202a\");\nrelated_curp_mujeres = form_mujeres.has_related_curp_registrations(\"curp_text\", curp, \"\", related_curps);\nif (related_curp_mujeres != null) {\nregister_get = related_curp_mujeres.get(\"register\");\naprobado = get_nested_value(register_get, \"answers.q234.0.value\");\nif (aprobado == null) {\nreturn true;\n} else {\nreturn \"TU REGISTRO DE ACTUALIZACIÓN ES MAÑANA [REVISAR MENSAJE]\";\n}\n} else {\nreturn true;\n}\n} else {\nreturn \"YA ESTÁS REGISTRADO EN ESTE PROGRAMA [REVISAR MENSAJE :)]\";\n}";
                  /**** DAY TWO ****/
                  // question.options.serverValidation.flux = "form = Form();\nregister = form.get_register();\ncurp = register.get_value(\"curp_texto\");\nrelated_curps = register.get_value(\"related_curps\");\nrelated_curp = register.has_related_curp_registrations(\"curp_texto\", curp, \"related_curps\", related_curps);\nif (related_curp == null) {\nform_mujeres = Form(\"63f5234b4732de0015a3202a\");\nrelated_curp_mujeres = form_mujeres.has_related_curp_registrations(\"curp_text\", curp, \"\", related_curps);\nif (related_curp_mujeres != null) {\nrelated_curp_mujeres_get = related_curp_mujeres.get(\"register\");\naprobado = get_nested_value(related_curp_mujeres_get, \"answers.q234.0.value\");\n# DIA 2\nif (aprobado == null) {\nreturn \"ESTE USUARIOS NO SE ENCUENTRA DENTRO DE LO PREVISTO EN EL ART.20 DE LAS REGLAS DE OPERACIÓN DEL PROGRAMA COMEMOS TODOS 2024\";\n} else {\nreturn true;\n}\n} else {\nreturn \"ESTE USUARIOS NO SE ENCUENTRA DENTRO DE LO PREVISTO EN EL ART.20 DE LAS REGLAS DE OPERACIÓN DEL PROGRAMA COMEMOS TODOS 2024\";\n}\n} else {\nreturn \"TU REGISTRO FUE RENOVADO CON ÉXITO\";\n}";
                  question.options.serverValidation.flux = "return \"\";";
                  console.log('ffffffffffffffffffffflx.2: ', question.options.serverValidation.flux);
                }
              }
              await database.set({
                type: 'forms',
                value: form,
                update: true,
              });
            }
          }

          rootGizmoConfigs = rootGizmoConfigs.concat(
            forms.map(f => rootGizmoConfigV2ToV3({ config: f }))
          );
        }
      }
    } catch (e) {}

    resolve(rootGizmoConfigs);
  });
}

export default getFormSignup;
